var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("navbar"),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-3" }, [
        _c("div", { staticClass: "row" }, [
          _vm.flashdata
            ? _c(
                "div",
                { staticClass: "offset-md-4 col-md-4" },
                [
                  _c("b-alert", { attrs: { show: true, dismissible: "" } }, [
                    _vm._v("\n          Mensaje:\n          "),
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.flashdata) },
                    }),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12" },
            [_c("router-view", { key: _vm.$route.fullPath })],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }